import React from 'react';
import Icon from '@/components/ui/AppIcon';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-parchment/8 bg-obsidian py-16 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Marquee line */}
        <div className="overflow-hidden mb-12 opacity-20">
          <div className="flex gap-12 whitespace-nowrap text-[11vw] font-display font-light text-parchment leading-none select-none">
            Judith Carey &nbsp;·&nbsp; CPRW &nbsp;·&nbsp; Judith Carey &nbsp;·&nbsp; CPRW &nbsp;·&nbsp;
          </div>
        </div>

        {/* Contact CTA */}
        <div className="text-center mb-14">
          <p className="text-parchment/40 text-sm font-body mb-3 tracking-widest uppercase">Ready to command executive interviews?</p>
          <a
            href="mailto:jc.careerwriter@gmail.com"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-gold text-obsidian font-body font-semibold text-base hover:bg-gold-light transition-all duration-300 hover:shadow-gold group"
          >
            <Icon name="EnvelopeIcon" size={18} />
            jc.careerwriter@gmail.com
            <Icon name="ArrowRightIcon" size={14} className="group-hover:translate-x-0.5 transition-transform" />
          </a>
        </div>

        {/* Main footer row */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 border-t border-parchment/8 pt-10">
          {/* Logo + copyright */}
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 rounded-full bg-gold/15 border border-gold/20 flex items-center justify-center">
                <Icon name="PencilIcon" size={12} className="text-gold/60" />
              </div>
              <span className="font-display italic text-parchment/50 text-base">Judith Carey, CPRW</span>
            </div>
            <span className="text-parchment/30 text-sm font-body">© {currentYear} All Rights Reserved.</span>
          </div>

          {/* Links */}
          <div className="flex items-center gap-8 text-sm font-body font-medium text-parchment/50">
            <a href="#services" className="hover:text-parchment transition-colors gold-underline">Services</a>
            <a href="#process" className="hover:text-parchment transition-colors gold-underline">Process</a>
            <a href="#testimonials" className="hover:text-parchment transition-colors gold-underline">Testimonials</a>
            <a href="mailto:jc.careerwriter@gmail.com" className="hover:text-parchment transition-colors gold-underline">Contact</a>
          </div>

          {/* Credential badge */}
          <div className="flex items-center gap-2 px-4 py-2 rounded-full border border-gold/15 bg-gold/5">
            <Icon name="CheckBadgeIcon" size={14} className="text-gold/60" />
            <span className="text-gold/60 text-xs font-body font-semibold tracking-widest uppercase">Nationally Certified</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;